import React from 'react';
import ServicePage from './ServicePage';
import { IconShield, IconWind, IconClipboard } from '../../components/Icons';

const DATA = {
  icon: <IconShield size={32} />, category: 'mineria',
  title: 'Planes de Sostenimiento',
  subtitle: 'Análisis geomecánico y diseño de sistemas de soporte estructural para minas subterráneas.',
  norm: 'Decreto 1886 de 2015 – Art. 124 a 152',
  desc: 'Realizamos la caracterización geomecánica del macizo rocoso y diseñamos el sistema de sostenimiento adecuado para cada tipo de labor minera subterránea, garantizando la estabilidad estructural y la seguridad de los trabajadores.',
  details: [
    'Caracterización geomecánica del macizo rocoso',
    'Clasificación RMR y Q del macizo',
    'Diseño de cimbras, pernos, malla y shotcrete',
    'Cálculo de cargas y estabilidad de labores',
    'Control y seguimiento de deformaciones',
    'Protocolos de inspección periódica',
  ],
  related: [
    { icon: <IconWind size={18} />,      label: 'Planes de Ventilación', path: '/servicios/ventilacion' },
    { icon: <IconClipboard size={18} />, label: 'PTO',                   path: '/servicios/pto' },
  ],
};

export default function Sostenimiento() { return <ServicePage data={DATA} />; }
